import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { httpRequest } from 'utils/httpRequest';
import { Pagination } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import { toast } from 'react-toastify';
import CircleLoader from "components/loader/CircleLoader"
import { useLoader } from 'components/loader/useLoader';


const AssociateSRB = () => {

     const { loading, startLoading, stopLoading } = useLoader()

    const [AssociateSrbData, setAssociateSrbData] = useState([])

    const [activePage, setActivePage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [total, setTotal] = useState(0);

    const [data, setData] = useState([
        { id: 1, name: 'S Ramesh Tendulkar', description: 'This is Dummy Description', },
        { id: 2, name: 'Sarah Parker', description: 'This is Dummy Description', },
        { id: 3, name: 'Mike Tyson', description: 'This is Dummy Description', },
        { id: 4, name: 'Jade Raymond', description: 'This is Dummy Description', },
        { id: 5, name: 'Edward Newton', description: 'This is Dummy Description', },
        { id: 6, name: 'Lisa Davis', description: 'This is Dummy Description', },
        { id: 7, name: 'Mark Love', description: 'This is Dummy Description', },
    ]);

    const navigate = useNavigate();

    //pagination
    const handlePageChange = (page) => {
        setActivePage(page);
        fetchAssociateSrbData(page, limit);
    };



    //pagination



    const handleDelete = async (id, name) => {
        try {


            const response = await httpRequest(
                `associate/delete/${id}`,
                "DELETE",
                {

                },
                {},
                true,
                false
            );
            if (response?.code === 200) {
                toast.success("Associate srb deleted successfully.")

                const newTotal = total - 1;
                const maxPages = Math.ceil(newTotal / limit);
                const newPage = activePage > maxPages ? maxPages : activePage;

                setTotal(newTotal)
                setActivePage(newPage)
                fetchAssociateSrbData(newPage, limit)



            }

        } catch (error) {
            console.log(error);
       
        }
    };

    const handleEdit = (id) => {
        navigate(`/admin/edit-srb/${id}`)
    };



    const handleNavigationOnAddPodcast = () => {
        navigate("/admin/add-srb");
    }


    useEffect(() => {
        fetchAssociateSrbData(activePage, limit)
    }, [])




    const fetchAssociateSrbData = async (page = 1, pageLimit = 10) => {
        startLoading()
        try {


            const response = await httpRequest(
                "associate/list",
                "GET",
                {

                },
                {
                    page: page,
                    limit: pageLimit
                },
                true,
                false
            );
            if (response?.code === 200) {

                setAssociateSrbData(response?.data)
                setTotal(response?.total);
                setActivePage(response?.page);
                setLimit(response?.limit);


            }

        } catch (error) {
            console.log(error);
        }finally{
            stopLoading()
        }
    }



    return (
        <>


        {loading ? <CircleLoader/> :(    <div className="container-fluid py-4 mt-5">

                <div className="row">
                    <div className="col">
                        <div className="card shadow">
                            {/* Card Header */}
                            <div className="card-header border-0 d-flex justify-content-end">
                                <h3 className="mb-0 mr-auto">Associate SRB</h3>
                                <Button color="primary" size="sm" onClick={handleNavigationOnAddPodcast}>
                                    Add Associate SRB
                                </Button>
                            </div>

                            {/* Table */}
                            <div className="table-responsive">
                                <table className="table align-items-center table-flush">
                                    <thead className="thead-light">
                                        <tr>
                                            <th scope="col">S.No</th>
                                            <th scope="col"> Name</th>
                                            <th scope="col"> Description</th>
                                            <th scope="col">Action</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {AssociateSrbData && AssociateSrbData.length > 0 && AssociateSrbData.map((item, index) => (
                                            <tr key={item.id}>

                                                <td>
                                                    <span className="mb-0 text-sm font-weight-bold">
                                                    {(activePage - 1) * limit + index + 1}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="mb-0 text-sm font-weight-bold">
                                                        {item.name}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="mb-0 text-sm font-weight-bold" dangerouslySetInnerHTML={{ __html: item?.description }}>

                                                    </span>
                                                </td>


                                                <td>
                                                    <button
                                                        className="btn  btn-sm"
                                                        onClick={() => handleEdit(item._id)}

                                                        title="Delete"
                                                    >
                                                        <i className="fas fa-edit text-primary me-2" title="Edit"></i>

                                                    </button>
                                                    <button
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => handleDelete(item._id)}
                                                        title="Delete"
                                                    >
                                                        <i className="fas fa-trash"></i>

                                                    </button>

                                                </td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* Card Footer with Pagination */}
                            <div className="card-footer py-4">
                                <div className="d-flex justify-content-end">
                                    <Pagination
                                        size="sm"
                                        total={total}
                                        limit={limit}
                                        activePage={activePage}
                                        onChangePage={handlePageChange}
                                        maxButtons={5}
                                        prev
                                        next
                                        last
                                        first
                                        ellipsis
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>)}



        </>
    );
};

export default AssociateSRB;